Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.SessionCustomChartListItemView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/session_chart_list_item']
  tooltipTemplate: JST['backbone/templates/common/dashboard/charts/custom_chart_creator/tooltip']
  tagName: 'li'
  className: 'chart-to-add'

  events:
    'click': 'openModal'

  initialize: (@session) ->

  render: ->
    @$el.html @template
      title: I18n.t('monitoring.dashboard.actions.add_custom_chart')
    @

  openModal: ->
    custom_chart_creator_view = new Common.Dashboard.Charts.CustomChartCreatorView(@session)
    modalView = new Common.Modals.ModalView
      title: "#{I18n.t('monitoring.dashboard.charts.custom_chart_creator')} #{@tooltipTemplate()}"
      contentView: custom_chart_creator_view.render()
      size:
        width: 750
        height: 530
    modalView.render()
